export default "/images/crypto_environments/crypto_environments__icons.png";